'use es6';

//
// only modify this file with property descriptions whose readOnlyDefinition is set to false
//
export const mutableDescriptionDefaults = {
  '0-1': {
    annualrevenue: 'Annual company revenue',
    company_size: "A contact's company size. This property is required for the Facebook Ads Integration. This property will be automatically synced via the Lead Ads tool",
    country: "The contact's country/region of residence. This might be set via import, form, or integration.",
    date_of_birth: "A contact's date of birth. This property is required for the Facebook Ads Integration. This property will be automatically synced via the Lead Ads tool",
    degree: "A contact's degree. This property is required for the Facebook Ads Integration. This property will be automatically synced to via Lead Ads tool",
    field_of_study: "A contact's field of study. This property is required for the Facebook Ads Integration. This property will be automatically synced via the Lead Ads tool",
    gender: '',
    graduation_date: "A contact's graduation date. This property is required for the Facebook Ads Integration. This property will be automatically synced via the Lead Ads tool",
    hs_facebook_ad_clicked: 'Whether contact has clicked a Facebook ad',
    hs_facebookid: "A contact's facebook id",
    hs_google_click_id: '',
    hs_googleplusid: "A contact's googleplus id",
    hs_linkedinid: "A contact's linkedin id",
    hs_twitterid: "A contact's twitter id",
    industry: 'The industry a contact is in',
    job_function: "A contact's job function. This property is required for the Facebook Ads Integration. This property will be automatically synced via the Lead Ads tool",
    marital_status: "A contact's marital status. This property is required for the Facebook Ads Integration. This property will be automatically synced via the Lead Ads tool",
    military_status: "A contact's military status. This property is required for the Facebook Ads Integration. This property will be automatically synced via the Lead Ads tool",
    numemployees: 'The number of company employees',
    owneremail: 'A legacy property used to identify the email address of the owner of the contact. This property is no longer in use.',
    relationship_status: "A contact's relationship status. This property is required for the Facebook Ads Integration. This property will be automatically synced via the Lead Ads tool",
    salutation: 'The title used to address a contact',
    school: "A contact's school. This property is required for the Facebook Ads Integration. This property will be automatically synced via the Lead Ads tool",
    seniority: "A contact's seniority. This property is required for the Facebook Ads Integration. This property will be automatically synced via the Lead Ads tool",
    start_date: "A contact's start date. This property is required for the Facebook Ads Integration. This property will be automatically synced via the Lead Ads tool",
    state: "The contact's state of residence. This might be set via import, form, or integration.",
    work_email: "A contact's work email. This property is required for the Facebook Ads Integration. This property will be automatically synced via the Lead Ads tool"
  },
  '0-3': {
    closed_lost_reason: 'Reason why this deal was lost',
    closed_won_reason: 'Reason why this deal was won'
  },
  '0-5': {
    hs_ticket_category: 'Main reason customer reached out for help',
    tags: 'Tags associated with your tickets'
  }
};